import React from 'react';
import Breadcrumb from '../../../core/layout/Breadcrumb';
import ActiveContractFormContainer from './ConfirmRenewalContractFormContainer';
import ActivateContractProductsModalContainer from './ConfirmRenewalContractProductsModalContainer';

const ConfirmRenewalContractFormScene = (props) => (
  <>
    <Breadcrumb
      crumbs={[
        ...(props.location.state && props.location.state.from
          ? [{ text: props.location.state.from.text, link: props.location.state.from.pathname }]
          : []),
        {
          text: 'Confirm Renewal',
        },
      ]}
    />
    <ActiveContractFormContainer contractId={props.params.contractId} />
    <ActivateContractProductsModalContainer />
  </>
);

export default ConfirmRenewalContractFormScene;
